import Vue from 'vue'
import VueRouter from 'vue-router'
import { isRunningInElectron } from '@/utils/electronUtils'

Vue.use(VueRouter)

// quit -- 用于点击关闭时判断是否能关闭程序
const routes = [
  {
    path: '/',
    redirect: isRunningInElectron() ? '/login' : '/home'
  },
  {
    path: '/suspension',
    name: 'Suspension',
    component: () => import('@/views/Suspension/index.vue')
  },
  {
    path: '/choose-class',
    name: 'ChooseClass',
    meta: { quit: true, isParticular: true, title: '选择授课班级' },
    component: () => import('@/views/ChooseClass/chooseClass')
  },
  // {
  //   path: '/teaching-materials',
  //   name: 'TeachingMaterials',
  //   meta: { quit: true, isParticular: true, title: '教辅教材' },
  //   component: () => import('@/views/TeachingMaterials/teachingMaterials')
  // },
  {
    path: '/silent-login',
    name: 'SilentLogin',
    meta: { quit: true, isHome: true, title: '登录' },
    component: () => import('@/views/SilentLogin/index.vue')
  },
  {
    path: '/home',
    name: 'Home',
    meta: { quit: true, isParticular: true, title: '教辅教材' },
    component: () => import('@/views/TeachingMaterials/teachingMaterials')
  },
  {
    path: '/iframe-page',
    name: 'iframePage',
    meta: { quit: true, isHome: true, title: '', isShowTitle: true },
    component: () => import('@/views/IframePage/index.vue')
  },
  // {
  //   path: '/home',
  //   name: 'Home',
  //   meta: { quit: true, isHome: true, isParticular: true, title: '首页' },
  //   component: () => import('@/views/Home/wordDictationList.vue')
  // },
  {
    path: '/login',
    name: 'Login',
    meta: { quit: true, isHome: true, isParticular: true, title: '登录页' },
    component: () => import('@/views/Login')
  },
  {
    path: '/teaching-assistant',
    name: 'TeachingAssistant',
    meta: { quit: true, isParticular: true, title: '教辅' },
    component: () => import('@/views/TeachingMaterials/teachingAssistant.vue')
  },
  {
    path: '/unit-detail',
    name: 'UnitDetail',
    meta: { quit: true, title: '单元', isShowTitle: true },
    component: () => import('@/views/UnitDetail/unitDetail')
  },
  {
    path: '/picture-book-page',
    name: 'PictureBookPage',
    meta: { quit: true, title: '绘本页面', isShowTitle: true },
    component: () => import('@/views/PictureBookPage/pictureBookPage')
  },
  // 授课-绘本页面
  {
    path: '/teaching-picture-book-page',
    name: 'TeachingPictureBookPage',
    meta: { quit: true, title: '绘本页面', isShowTitle: true, type: 'teaching' },
    component: () => import('@/views/PictureBookPage/pictureBookPage2')
  },
  // 电子教材-绘本页面
  {
    path: '/textbook-picture-book-page',
    name: 'TextbookPictureBookPage',
    meta: { quit: true, title: '绘本页面', isShowTitle: true, type: 'textbook' },
    component: () => import('@/views/PictureBookPage/pictureBookPage2')
  },
  // 数字绘本-绘本页面
  {
    path: '/digital-picture-book-page',
    name: 'DigitalPictureBookPage',
    meta: { quit: true, title: '绘本页面', isShowTitle: true, type: 'textbook' },
    component: () => import('@/views/PictureBookPage/pictureBookPage3')
  },
  // 数字绘本-基础练习
  {
    path: '/basic-exercises',
    name: 'BasicExercises',
    meta: { quit: true, title: '基础练习', isShowTitle: true, type: 'textbook' },
    component: () => import('@/views/BasicExercises/index')
  },
  // 智能单词
  {
    path: '/smart-word',
    name: 'SmartWord',
    meta: { quit: true, title: '智能单词' },
    component: () => import('@/views/SmartWord/index'),
    children: [
      {
        path: 'book-list',
        name: 'WordBookList',
        meta: { quit: true, title: '书籍列表' },
        component: () => import('@/views/SmartWord/bookList')
      },
      {
        path: 'bookshelf',
        name: 'WordBookshelf',
        meta: { quit: true, title: '书架' },
        component: () => import('@/views/SmartWord/bookshelf.vue')
      },
      {
        path: 'book-detail',
        name: 'WordBookDetail',
        meta: { quit: false, title: '书籍详情' },
        component: () => import('@/views/SmartWord/bookDetail')
      },
      {
        path: 'word-dictation',
        name: 'WordDictation',
        meta: { quit: true, title: '纸笔听写' },
        component: () => import('@/views/SmartWord/components/wordDictation')
      },
      {
        path: 'see-word-selection',
        name: 'SeeWordSelection',
        meta: { quit: true, title: '看词选义' },
        component: () => import('@/views/SmartWord/components/seeWordSelection.vue')
      },
      {
        path: 'choose-words-by-hearing',
        name: 'ChooseWordsByHearing',
        meta: { quit: true, title: '听音选词' },
        component: () => import('@/views/SmartWord/components/ChooseWordsByHearing.vue')
      },
      {
        path: 'choose-words-by-look',
        name: 'ChooseWordsByLook',
        meta: { quit: true, title: '看图识词' },
        component: () => import('@/views/SmartWord/components/ChooseWordsByLook')
      },
      {
        path: 'choose-meaning-by-hearing',
        name: 'ChooseMeaningByHearing',
        meta: { quit: true, title: '听词选义' },
        component: () => import('@/views/SmartWord/components/ChooseMeaningByHearing')
      },
      {
        path: 'word-read-aloud',
        name: 'WordReadAloud',
        meta: { quit: false, answer: true, title: '单词朗读' },
        component: () => import('@/views/SmartWord/wordReadAloud')
      },
      {
        path: 'word-read',
        name: 'WordRead',
        meta: { quit: false, answer: true, title: '单词领读' },
        component: () => import('@/views/SmartWord/wordRead')
      }
    ]
  },
  // 课文听读
  {
    path: '/listen-read-text',
    name: 'ListenReadText',
    meta: { quit: true, title: '课文听读' },
    component: () => import('@/views/ListenReadText/index'),
    children: [
      {
        path: 'book-list',
        name: 'TextList',
        meta: { quit: true, title: '书籍列表' },
        component: () => import('@/views/ListenReadText/bookList')
      },
      {
        path: 'bookshelf',
        name: 'TextBookshelf',
        meta: { quit: true, title: '书架' },
        component: () => import('@/views/ListenReadText/bookshelf.vue')
      },
      {
        path: 'book-detail',
        name: 'TextBookDetail',
        meta: { quit: true, answer: true, title: '书籍详情' },
        component: () => import('@/views/ListenReadText/bookDetail')
      },
      {
        path: 'lead-read-text',
        name: 'LeadReadText',
        meta: { quit: true, answer: true, title: '领读课文' },
        component: () => import('@/views/ListenReadText/LeadReadText')
      },
      {
        path: 'read-text-sentence',
        name: 'ReadTextSentence',
        meta: { quit: true, answer: true, title: '句子朗读' },
        component: () => import('@/views/ListenReadText/readTextSentence.vue')
      }
    ]
  },
  // 句子巩固
  {
    path: '/sentence-consolidation',
    name: 'SentenceConsolidation',
    meta: { quit: true, title: '句子巩固' },
    component: () => import('@/views/SentenceConsolidation/index.vue'),
    children: [
      {
        path: 'sentence-list',
        name: 'SentenceList',
        meta: { quit: true, title: '句子巩固' },
        component: () => import('@/views/SentenceConsolidation/sentenceList.vue')
      },
      {
        path: 'read-sentence',
        name: 'ReadSentence',
        meta: { quit: true, answer: true, title: '朗读句子' },
        component: () => import('@/views/SentenceConsolidation/readSentence.vue')
      },
      {
        path: 'choose-sentence-by-hearing',
        name: 'ChooseSentenceByHearing',
        meta: { quit: true, answer: true, title: '听选句子' },
        component: () => import('@/views/SentenceConsolidation/chooseSentenceByHearing.vue')
      }
    ]
  },
  // 我的教辅
  {
    path: '/teaching-auxiliary',
    name: 'TeachingAuxiliary',
    meta: { quit: true, title: '我的教辅' },
    component: () => import('@/views/TeachingAuxiliary/index'),
    children: [
      {
        path: 'book-list',
        name: 'AuxiliaryBookList',
        meta: { quit: true, title: '书籍列表' },
        component: () => import('@/views/TeachingAuxiliary/bookList')
      },
      {
        path: 'bookshelf',
        name: 'AuxiliaryBookshelf',
        meta: { quit: true, title: '书架' },
        component: () => import('@/views/TeachingAuxiliary/bookshelf.vue')
      },
      {
        path: 'auxiliary-answer',
        name: 'AuxiliaryAnswer',
        meta: { quit: true },
        component: () => import('@/views/TeachingAuxiliary/answer')
      }
    ]
  },
  // 本地专版
  {
    path: '/regional-special',
    name: 'RegionalSpecial',
    meta: { quit: true, title: '本地专版' },
    component: () => import('@/views/RegionalSpecial/index'),
    children: [
      {
        path: 'book-list',
        name: 'SpecialBookList',
        meta: { quit: true, title: '书籍列表' },
        component: () => import('@/views/RegionalSpecial/bookList')
      },
      {
        path: 'bookshelf',
        name: 'SpecialBookshelf',
        meta: { quit: true, title: '书架' },
        component: () => import('@/views/RegionalSpecial/bookshelf.vue')
      }
    ]
  },
  // PK
  {
    path: '/pk-container',
    name: 'PkContainer',
    meta: { quit: true },
    component: () => import('@/views/Pk'),
    children: [
      {
        path: '/create-pk',
        name: 'CreatePk',
        meta: { quit: true },
        component: () => import('@/views/Pk/createPk')
      },
      {
        path: '/pk-select-book',
        name: 'PkSelectBook',
        meta: { quit: true },
        component: () => import('@/views/Pk/selectBook')
      },
      {
        path: '/pk-select-unit',
        name: 'PkSelectUnit',
        meta: { quit: true },
        component: () => import('@/views/Pk/selectUnit')
      },
      {
        path: '/pk-select-word',
        name: 'PkSelectWord',
        meta: { quit: true },
        component: () => import('@/views/Pk/selectWord')
      },
      {
        path: '/pk',
        name: 'Pk',
        meta: { quit: true, isPk: true },
        component: () => import('@/views/Pk/pk')
      },
      {
        path: '/pk-record',
        name: 'PkRecord',
        meta: { quit: true },
        component: () => import('@/views/Pk/pkRecord')
      }
    ]
  },
  {
    path: '/Text',
    name: 'TextPage',
    meta: { quit: true },
    component: () => import('@/views/Test/index'),
    children: [
      {
        // 手动模式
        path: 'accent-detail',
        name: 'AccentDetail',
        meta: { quit: true, answer: true, title: '听说题' },
        component: () => import('@/views/Test/accentDetail')
      },
      // 自动模式
      {
        path: 'paper-detail',
        name: 'PaperDetail',
        meta: { quit: true, answer: true, title: '听说题' },
        component: () => import('@/views/Test/paperDetail')
      },
      // 笔试题
      {
        path: 'written-detail',
        name: 'WrittenDetail',
        meta: { quit: true, answer: true, title: '笔试题' },
        component: () => import('@/views/Test/writtenDetail')
      },
      // 设备测试
      {
        path: 'equipment-test',
        name: 'EquipmentTest',
        meta: { quit: true, answer: true, title: '模拟考试' },
        component: () => import('@/views/Test/equipmentTest')
      },
      // 模拟考试
      {
        path: 'mock-test',
        name: 'MockTest',
        meta: { quit: true, answer: true, title: '模拟考试' },
        component: () => import('@/views/Test/mockTest')
      }
    ]
  },
  // 授课管理
  {
    path: '/teaching-package',
    name: 'TeachingPackage',
    meta: { quit: true },
    component: () => import('@/views/TeachingPackage/index'),
    children: [
      {
        path: 'teaching-management',
        name: 'TeachingManagement',
        meta: { quit: true, answer: true, title: '授课管理' },
        component: () => import('@/views/TeachingPackage/teachingManagement')
      },
      {
        path: 'package-edit',
        name: 'PackageEdit',
        meta: { quit: true, answer: true, title: '授课包管理' },
        component: () => import('@/views/TeachingPackage/packageEdit')
      },
      {
        path: 'electronic-text-add',
        name: 'electronicTextAdd',
        meta: { quit: true, answer: true, title: '新增电子课文' },
        component: () => import('@/views/TeachingPackage/electronicTextAdd')
      }
    ]
  },
  // 音标学习
  {
    path: '/soundmark-learning',
    name: 'SoundmarkLearning',
    meta: { quit: true },
    component: () => import('@/views/SoundmarkLearning/index'),
    children: [
      {
        path: 'soundmark-list',
        name: 'SoundmarkList',
        meta: { quit: true, answer: true, title: '音标列表' },
        component: () => import('@/views/SoundmarkLearning/SoundmarkList')
      },
      {
        path: 'soundmark-practice',
        name: 'SoundmarkPractice',
        meta: { quit: false, answer: true, title: '音标学习' },
        component: () => import('@/views/SoundmarkLearning/SoundmarkPractice')
      },
      {
        path: 'word--practice',
        name: 'WordPractice',
        meta: { quit: false, answer: true, title: '单词练习' },
        component: () => import('@/views/SoundmarkLearning/WordPractice.vue')
      }
    ]
  },
  // 电子课本
  {
    path: '/digital-library',
    name: 'DigitalLibrary',
    meta: { quit: true, title: '电子课本', isShowTitle: true },
    component: () => import('@/views/DigitalLibrary/DigitalLibrary')
  },
  // 作业报告
  {
    name: 'HomeworkReport',
    path: '/homework-report',
    meta: { quit: true, title: '检查作业' },
    component: () => import('@/views/HomeworkReport/index.vue'),
    redirect: '/homework-report/check-homework',
    children: [
      {
        name: 'CheckHomework',
        path: 'check-homework',
        meta: { quit: true, title: '检查作业' },
        component: () => import('@/views/HomeworkReport/checkHomework.vue')
      },
      {
        name: 'HomeworkPackage',
        path: 'homework-package',
        meta: { quit: true, title: '作业包' },
        component: () => import('@/views/HomeworkReport/homeworkPackage.vue')
      },
      {
        name: 'HomeworkDetail',
        path: 'homework-detail',
        meta: { quit: true, title: '子作业' },
        component: () => import('@/views/HomeworkReport/homeworkDetail.vue')
      }
    ]
  },
  {
    name: 'AiAssistant',
    path: '/ai-assistant',
    meta: { quit: true, title: 'AI助手' },
    component: () => import('@/views/AiAssistant/index.vue'),
    children: [
      {
        path: 'ai-assistant-inner',
        name: 'AiAssistantInner',
        meta: { quit: true, title: 'AI助手内嵌页' },
        component: () => import('@/views/AiAssistant/InnerPage.vue')
      }
    ]
  },
  {
    name: 'VocabularyStudy',
    path: '/vocabulary-study',
    redirect: '/vocabulary-study/select-book',
    meta: { quit: true, title: '词汇' },
    component: () => import('@/views/VocabularyStudy/index.vue'),
    children: [
      {
        path: 'select-book',
        name: 'VocabularyStudySelectBook',
        meta: { quit: true, title: '词汇选择书本' },
        component: () => import('@/views/VocabularyStudy/SelectBook.vue')
      },
      {
        path: 'select-word',
        name: 'VocabularyStudySelectWord',
        meta: { quit: true, title: '词汇选择单词' },
        component: () => import('@/views/VocabularyStudy/SelectWord.vue')
      },
      {
        path: 'select-word-read-aloud',
        name: 'SelectWordReadAloud',
        meta: { quit: false, answer: true, title: ' 选择单词朗读' },
        component: () => import('@/views/VocabularyStudy/SelectWordReadAloud')
      }
    ]
  },
  {
    name: 'FunnyDubbing',
    path: '/funny-dubbing',
    redirect: '/funny-dubbing/dub-album-list',
    meta: { quit: true, title: '趣味配音' },
    component: () => import('@/views/FunnyDubbing/index.vue'),
    children: [
      {
        path: 'dub-album-list',
        name: 'DubAlbumList',
        meta: { quit: true, title: '配音专辑' },
        component: () => import('@/views/FunnyDubbing/dubAlbumList.vue')
      },
      {
        path: 'all-dub-album-list',
        name: 'AllDubAlbumList',
        meta: { quit: true, title: '全部专辑' },
        component: () => import('@/views/FunnyDubbing/allDubAlbumList.vue')
      },
      {
        path: 'dub-album-detail',
        name: 'DubAlbumDetail',
        meta: { quit: true, title: '专辑详情' },
        component: () => import('@/views/FunnyDubbing/dubAlbumDetail.vue')
      },
      {
        path: 'dub-detail',
        name: 'DubDetail',
        meta: { quit: true, title: '配音详情' },
        component: () => import('@/views/FunnyDubbing/dubDetail.vue')
      }
    ]
  },
  {
    name: 'PaperCollect',
    path: '/paper-collect',
    redirect: '/paper-collect/paper-collect-list',
    meta: { quit: true, title: '答卷收集' },
    component: () => import('@/views/PaperCollect/index.vue'),
    children: [
      {
        path: 'paper-collect-list',
        name: 'PaperCollectList',
        meta: { quit: true, title: '答卷收集列表' },
        component: () => import('@/views/PaperCollect/paperCollectList.vue')
      },
      {
        path: 'create-paper-collect',
        name: 'CreatePaperCollect',
        meta: { quit: true, title: '创建答卷收集' },
        component: () => import('@/views/PaperCollect/createPaperCollect.vue')
      },
      {
        path: 'paper-collect-detail',
        name: 'PaperCollectDetail',
        meta: { quit: true, title: '答卷收集详情' },
        component: () => import('@/views/PaperCollect/paperCollectDetail.vue')
      }
    ]
  },
  {
    name: 'AnswerHistory',
    path: '/answer-history',
    redirect: '/answer-history/answer-history-list',
    meta: { quit: true, title: '作答历史' },
    component: () => import('@/views/AnswerHistory/index.vue'),
    children: [
      {
        path: 'answer-history-list',
        name: 'AnswerHistoryList',
        meta: { quit: true, title: '作答历史列表' },
        component: () => import('@/views/AnswerHistory/answerHistroyList.vue')
      }
    ]
  },
  {
    path: '/word-dictation',
    name: 'WordDictation',
    component: () => import('@/views/WordDictation/index.vue'),
    children: [
      {
        path: '/word-dictation/word-bank-page',
        name: 'WordBankPage',
        meta: { quit: true, title: '单词库' },
        component: () => import('@/views/WordDictation/wordBankPage.vue')
      },
      {
        path: '/word-dictation/word-dictation-list',
        name: 'WordDictationList',
        meta: { quit: true, title: '单词听写列表' },
        component: () => import('@/views/WordDictation/wordDictationList.vue')
      },
      {
        path: '/word-dictation/create-dictation',
        name: 'CreateDictation',
        meta: { quit: true, title: '创建听写任务' },
        component: () => import('@/views/WordDictation/createDictation.vue')
      },
      {
        path: '/word-dictation/add-word-from-word-bank',
        name: 'AddWordFromWordBank',
        meta: { quit: true, title: '创建听写任务-添加词库单词' },
        component: () => import('@/views/WordDictation/addWordFromWordBank.vue')
      },
      {
        path: '/word-dictation/dictation-page',
        name: 'DictationPage',
        meta: { quit: true, title: '单词听写' },
        component: () => import('@/views/WordDictation/dictationPage.vue')
      },
      {
        path: '/word-dictation/dictation-report',
        name: 'DictationReport',
        meta: { quit: true, title: '单词听写-批改报告' },
        component: () => import('@/views/WordDictation/dictationReport.vue')
      },
      {
        path: '/word-dictation/dictation-history',
        name: 'DictationHistory',
        meta: { quit: true, title: '听写历史' },
        component: () => import('@/views/WordDictation/dictationHistory.vue')
      },
      {
        path: '/word-dictation/student-report',
        name: 'WordDictationStudentReport',
        meta: { quit: true, title: '单词听写-学生听写报告' },
        component: () => import('@/views/WordDictation/studentReport.vue')
      },
      {
        path: '/word-dictation/upload-dictation',
        name: 'UploadDictation',
        meta: { quit: true, title: '单词听写-上传听写单' },
        component: () => import('@/views/WordDictation/uploadDictation.vue')
      }
    ]
  }
]

// 防止路由重复点击报错
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
